var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourceLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 0C1.883 0 0 1.883 0 4.2C0 5.614 0.819 6.797 1.771 7.623C2.072 7.882 2.597 8.295 3.066 8.904C3.584 9.583 4.053 10.311 4.2 10.801C4.347 10.311 4.816 9.583 5.334 8.904C5.803 8.295 6.328 7.882 6.629 7.623C7.581 6.797 8.4 5.614 8.4 4.2C8.4 1.883 6.517 0 4.2 0ZM4.2 1.792C4.51622 1.792 4.82935 1.85429 5.1215 1.9753C5.41365 2.09631 5.67911 2.27368 5.90271 2.49729C6.12632 2.72089 6.30369 2.98635 6.4247 3.2785C6.54571 3.57065 6.608 3.88378 6.608 4.2C6.608 4.51622 6.54571 4.82935 6.4247 5.1215C6.30369 5.41365 6.12632 5.67911 5.90271 5.90271C5.67911 6.12632 5.41365 6.30369 5.1215 6.4247C4.82935 6.54572 4.51622 6.608 4.2 6.608C3.56136 6.608 2.94887 6.3543 2.49729 5.90271C2.0457 5.45113 1.792 4.83864 1.792 4.2C1.792 3.56136 2.0457 2.94887 2.49729 2.49729C2.94887 2.0457 3.56136 1.792 4.2 1.792Z",
    fill: "#118ED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceLocation);
export default __webpack_public_path__ + "static/media/source-location.1431d702751c0daaa7d21dacb1dc4a3d.svg";
export { ForwardRef as ReactComponent };